import React from "react";

import { Button } from "../../../components/Button";
import { Drawer } from "../../../components/Drawer";

import { CurrencyInput } from "@components/CurrencyInput";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import styles from "../../../../styles/block-order-interval.module.scss";
import { Loading } from "../../../components/Loading";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { BaseCurrencyInput, Label, Message } from "../../../components";
import Toggle2 from "shared/components/Toggle2";
import { If } from "shared/components/control-statements";

export default class BlockOrderInterval extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      minutesInterval: null,
      pageLoading: true,
      saveLoading: false,
    };
  }

  async componentDidMount() {
    const environmentId = EnvironmentStorage.getSelectedEnvironment();

    const configurations = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "order_interval_limit",
      []
    );

    this.setState({
      pageLoading: false,
      active: !!configurations?.active,
      minutesInterval: configurations?.minutesInterval || null,
    });
  }

  checkIfIsValid() {
    const { active, minutesInterval } = this.state;
    return !active || (active && minutesInterval > 0);
  }

  async save() {
    const { active, minutesInterval } = this.state;

    this.setState({ saveLoading: true });

    const environmentId = EnvironmentStorage.getSelectedEnvironment();

    const blockResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      environmentId,
      "order_interval_limit",
      {
        order_interval_limit: {
          active,
          minutesInterval,
        },
      }
    );

    if (blockResponse.getErrors([]).length > 0) {
      alert({
        text: blockResponse.getErrors()[0],
        buttonText: "Ok",
      });
      this.setState({ saveLoading: false });
      return false;
    }

    alert({
      text: "Configurações alteradas sucesso",
      buttonText: "Ok",
    });

    this.setState({ saveLoading: false });
    return true;
  }

  render() {
    const { visible, onClose } = this.props;
    const { active, minutesInterval, pageLoading, saveLoading } = this.state;

    const isValid = this.checkIfIsValid();

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Intervalo entre pedidos"
      >
        {pageLoading ? (
          <div className="d-flex align-center justify-center h-100 w-100">
            <Loading />
          </div>
        ) : (
          <>
            <Message type="warning" className="w-100 mb-20">
              <p>
                Ao ativar esta função, seu cliente terá de esperar um tempo
                mínimo após fazer um pedido, para realizar um pedido novamente.
              </p>
            </Message>

            <div className={styles.box}>
              <Toggle2
                id="payment-online"
                title="Ativar intervalo entre pedidos"
                checked={active}
                onChange={() => {
                  this.setState({
                    active: !active,
                  });
                }}
              />
            </div>

            <If cond={active}>
              <Label className="mb-0 mt-20">
                Insira o tempo mínimo para o próximo pedido
              </Label>
              <BaseCurrencyInput
                design="mini"
                className="w-100"
                max={11}
                suffix={` ${minutesInterval == 1 ? "minuto" : "minutos"}`}
                prefix=""
                precision={0}
                value={minutesInterval}
                onChange={(value) => this.setState({ minutesInterval: value })}
              />
            </If>

            <div className={styles.footer}>
              <Button
                className="w-100"
                design="primary"
                disabled={saveLoading || !isValid}
                loading={saveLoading}
                onClick={() => this.save()}
              >
                Salvar
              </Button>
            </div>
          </>
        )}
      </Drawer>
    );
  }
}
